module.exports = __webpack_public_path__ + "static/img/pattern-left.479cbd89.png";